import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cc59603"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overall-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "attachments-wrapper"
}
const _hoisted_3 = { class: "attachment" }

import { Attachment } from "@/store/chats/types";
import { IconType } from "@/types/icons";
import InputAttachmentPreview from "./InputAttachmentPreview.vue"
import Icon from "@/components/icons/Icon/Icon.vue"

interface Props {
  attachments: Attachment[];
}
interface Emits {
  (e: "add-attachment", files: FileList): void;
  (e: "remove-attachment", id: string | undefined): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputAttachmentWithPreview',
  props: {
    attachments: { default: () => [] }
  },
  emits: ["add-attachment", "remove-attachment"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const addAttachment = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const files = target.files;
  if (!files) {
    return;
  }
  emit("add-attachment", files);
};

const removeAttachment = (id?: string | undefined) => {
  if (!id) {
    return;
  }
  emit("remove-attachment", id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.attachments.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              class: "attachment-input",
              type: "file",
              onChange: addAttachment
            }, null, 32),
            _createVNode(Icon, {
              icon: _unref(IconType).GALLERY_PLUS,
              class: "btn-add"
            }, null, 8, ["icon"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment) => {
            return (_openBlock(), _createBlock(InputAttachmentPreview, {
              key: attachment.id,
              attachment: attachment,
              "remove-attachment": removeAttachment
            }, null, 8, ["attachment"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})